var render = function render(){var _vm=this,_c=_vm._self._c;return _c('profile-checks',{attrs:{"licence-data":_vm.activePerson.flyingData.groupChecks,"is-editable":_vm.isEditable},on:{"commitChanges":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }